<template>
  <div>
    <b-row>
      <b-col class="bold" cols="6">
        Sillones
        <v-select
            multiple
            :options="opcionesSillones"
            v-model="form.sillones"
            :reduce="o => o.value"
            label="text"
            placeholder="Selecciona sillones"
        />
      </b-col>
      <b-col class="bold" cols="6">
        Clínica
        <div>
          <span style="color: var(--color-dentalia); font-weight: bold">{{ nombreClinica }}</span>
        </div>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col><span class="bold">Fechas</span></b-col>
    </b-row>
    <br>
    <b-row>
      <b-col class="d-flex justify-content-center ml-3">
        <span class="pr-2 mt-2" style="color: rgb(142 142 142); font-weight: 600;">Desde</span>
        <b-form-datepicker
            style="height: 20px"
            dropright
            id="inh-fecha-inicio"
            v-model="form.fechaInicio"
            placeholder="Fecha"
            @input="form.fechaFin = null"
            :min="new Date()"
        ></b-form-datepicker>
      </b-col>
      <b-col class="d-flex justify-content-center">
        <span class="pr-2 mt-2" style="color: rgb(142 142 142); font-weight: 600;">Hasta</span>
        <b-form-datepicker
            style="height: 20px"
            dropright
            id="inh-fecha-fin"
            v-model="form.fechaFin"
            placeholder="Fecha"
            :disabled="form.fechaInicio == null"
            :min="form.fechaInicio"
        ></b-form-datepicker>
      </b-col>
    </b-row>
    <b-row v-if="listaDias.length > 0">
      <br>
      <b-col>
        Día:
        <b-row class="m-2 align-items-center no-gutters">
          <b-col class="m-2" cols="1" v-for="(dia, indexDias) in listaDias" :key="indexDias">
            <b-button
                :variant="dia.seleccionado ? 'primary' : 'outline-secondary'"
                @click="dia.seleccionado = !dia.seleccionado"
            >
              {{ dia.inicialDia }}
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col><span class="bold">Rango de horas</span></b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col class="d-flex justify-content-center align-items-center">
        <span class="pr-2" style="color: rgb(142 142 142); font-weight: 600;">Desde</span>
        <vue-timepicker
            v-model="form.horaInicio"
            format="HH:mm"
            hide-clear-button
            :minute-interval="15"
            close-on-complete
        ></vue-timepicker>
      </b-col>
      <b-col class="d-flex justify-content-center align-items-center">
        <span class="pr-2" style="color: rgb(142 142 142); font-weight: 600;">Hasta</span>
        <vue-timepicker
            v-model="form.horaFin"
            format="HH:mm"
            hide-clear-button
            :minute-interval="15"
            close-on-complete
        ></vue-timepicker>
      </b-col>
    </b-row>
    <b-row v-if="horaInicioNum !== null && horaFinNum !== null && !horasDentroDeRango">
      <b-col>
        <small class="text-danger">
          Las horas deben estar dentro del rango operativo del día y horaInicio menor a horaFin.
        </small>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col align="right">
        <b-button variant="outline-primary" pill :disabled="!formularioValido" @click="onGuardar">
          <span>Guardar</span>
        </b-button>
      </b-col>
      <b-col>
        <b-button variant="outline-secondary" pill @click="$emit('cerrar')">Cancelar</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "FormInhabilitarSillon",
  props: {
    listaSillones: { type: Array, required: true },
    nombreClinica: { type: String, required: true },
    idClinica: { type: Number, required: true },
    diasOperativos: { type: Array, required: true },
    listaDias: { type: Array, required: true },
    seleccionInhabilitar: { type: Object, required: true },
  },
  data: () => ({
    form: {
      sillones: [],
      fechaInicio: null,
      fechaFin: null,
      horaInicio: { HH: '', mm: '' },
      horaFin: { HH: '', mm: '' },
    },
  }),
  created() {
    if (this.seleccionInhabilitar.sillonSeleccionado != null) {
      this.form.sillones = [this.seleccionInhabilitar.sillonSeleccionado];
    }
    if (this.seleccionInhabilitar.fechaSelecionada != null) {
      this.form.fechaInicio = this.seleccionInhabilitar.fechaSelecionada;
    }
    const horario = this.horarioDiaSeleccionado || this.diasOperativos[0] || {};
    this.form.horaInicio = this.toPicker(horario.horaInicio);
    this.form.horaFin = this.toPicker(horario.horaFin);
  },
  computed: {
    opcionesSillones() {
      return this.listaSillones.map(s => ({ value: s.numeroSillon, text: `${s.numeroSillon}` }));
    },
    horarioDiaSeleccionado() {
      if (!this.seleccionInhabilitar.fechaSelecionada) return null;
      const fecha = new Date(this.seleccionInhabilitar.fechaSelecionada);
      const dow = fecha.getDay();
      return this.diasOperativos.find(d => Number(d.dia) === dow) || null;
    },
    diasOperativosSeleccionados() {
      const diasSel = this.listaDias.filter(d => d.seleccionado).map(d => Number(d.dia));
      if (diasSel.length === 0) return this.diasOperativos;
      return this.diasOperativos.filter(d => diasSel.includes(Number(d.dia)));
    },
    horaInicioNum() {
      return this.form.horaInicio.HH !== '' ? this.fromPicker(this.form.horaInicio) : null;
    },
    horaFinNum() {
      return this.form.horaFin.HH !== '' ? this.fromPicker(this.form.horaFin) : null;
    },
    horasDentroDeRango() {
      if (this.horaInicioNum === null || this.horaFinNum === null) return false;
      if (this.horaInicioNum >= this.horaFinNum) return false;
      const dias = this.diasOperativosSeleccionados;
      if (dias.length === 0) return true;
      return dias.every(d => {
        const ini = Number(d.horaInicio);
        const fin = Number(d.horaFin);
        return this.horaInicioNum >= ini && this.horaFinNum <= fin;
      });
    },
    formularioValido() {
      const hayDia = this.listaDias.some(d => d.seleccionado);
      const horaOk = this.form.horaInicio.HH !== '' && this.form.horaFin.HH !== '';
      return this.form.sillones.length > 0
          && this.form.fechaInicio != null
          && this.form.fechaFin != null
          && hayDia
          && horaOk
          && this.horasDentroDeRango;
    },
  },
  methods: {
    toPicker(valor) {
      if (valor == null) return { HH: '', mm: '' };
      const str = valor.toString().padStart(4, '0');
      return { HH: str.substring(0, 2), mm: str.substring(2, 4) };
    },
    fromPicker(picker) {
      return Number(picker.HH) * 100 + Number(picker.mm);
    },
    onGuardar() {
      this.$emit('inhabilitar', {
        idClinica: this.idClinica,
        sillones: this.form.sillones,
        dias: this.listaDias.filter(d => d.seleccionado).map(d => d.dia),
        fechaInicio: this.form.fechaInicio,
        fechaFin: this.form.fechaFin,
        horaInicio: this.fromPicker(this.form.horaInicio),
        horaFin: this.fromPicker(this.form.horaFin),
      });
    },
  },
}
</script>
